export default [
  {
    name: 'Power Ups Config',
    path: 'powerups',
    component: () => import('@/views/powerups/Config.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Power Ups' }
      ]
    }
  },
  {
    name: 'Power Ups Adicionar',
    path: 'powerups/edit',
    component: () => import('@/views/powerups/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Power Ups', path: '/administracao/powerups' },
        { name: 'Adicionar' }
      ]
    }
  },
  {
    name: 'Power Ups Editar',
    path: 'powerups/edit/:id',
    component: () => import('@/views/powerups/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Power Ups', path: '/administracao/powerups' },
        { name: 'Editar' }
      ]
    }
  }
]
